// @flow

const urlHelper = {

  // Base from env
  base: () => {
    return window.URL_BASE;
  },

  // Get base url for Rails app
  baseUrl: (url: string = '') => {
    if( url === '' ) {
      return urlHelper.base();
    }
    return urlHelper.base() + '/' + url;
  },

  // Return image URL with base part
  imageUrl: (url: string = '', checkExist: boolean = false) => {
    if( url === '' ) return false;
    let imageNewUrl = urlHelper.isExternalUrl(url) ? url : urlHelper.baseUrl() + '/' + url;

    if( checkExist ) {
      // Check if image doesn't exists in large folder
      if( !urlHelper.imageExists(imageNewUrl) ) {
        imageNewUrl = imageNewUrl.replace('/large/', '/medium/');
        if( !urlHelper.imageExists(imageNewUrl) ) {
          imageNewUrl = imageNewUrl.replace('/medium/', '/small/');
        }
      }
    }

    return imageNewUrl;
  },

  // Check if image exists
  imageExists: (url: string = '') => {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();

    return http.status !== 404;
  },

  // Check if string is external URL
  isExternalUrl: (url: string = '') => {
    return (/^(f|ht)tps?:\/\//i.test(url));
  },

  baseApi: () => {
    return window.URL_API_BASE;
  },

  baseApiUrl: (url: string = '') => {
    if( url === '' ) {
      return urlHelper.baseApi();
    }
    return urlHelper.baseApi() + '/' + url;
  },
}

export default urlHelper;



// WEBPACK FOOTER //
// ./src/helpers/url.helper.js